import React, { useCallback } from 'react';
import type { Portfolio } from 'venn-api';
import type { SearchMenuItem } from '../../search-menu';
import SearchMenuModal from '../../search-menu/SearchMenuModal';
import { useAllocationSearch } from './AllocationSearchContext';
import { AddInvestmentCommonHeader } from '../../modals/add-investment-common-modal';
import { ModalFooter } from '../../modal';
import { Button } from 'venn-ui-kit';

interface AllocationSearchInvestmentViewRedesignedProps {
  onClose: () => void;
  strategy: Portfolio;
  allowBackStep?: boolean;
}

export const AllocationSearchInvestmentViewRedesigned: React.FC<AllocationSearchInvestmentViewRedesignedProps> = ({
  onClose,
  strategy,
  allowBackStep = false,
}) => {
  const { selectedConstituent, handleSingleSelectFund, handleBack } = useAllocationSearch();

  const handleSelected = useCallback(
    async (item: SearchMenuItem) => {
      await handleSingleSelectFund(item);
    },
    [handleSingleSelectFund],
  );

  const excludedItems = (strategy.children || [])
    .filter((child) => child.fund)
    .map(({ fund }) => ({
      id: fund!.id,
      type: 'FUND' as const,
    }));

  const redesignedTitle = selectedConstituent ? (
    <>
      <strong>Add investment to: </strong>
      {selectedConstituent.name}
    </>
  ) : (
    <strong>Add investment</strong>
  );

  return (
    <>
      <AddInvestmentCommonHeader title={redesignedTitle} onClose={onClose} />
      <div className="flex-grow flex flex-col overflow-hidden [_.qa-search-menu-modal-table]:max-h-[380px] px-0 mt-[16px]">
        <SearchMenuModal
          onSelected={handleSelected}
          location="allocation-panel"
          investmentsOnly
          autofocus
          defaultMenuIsOpen
          privateAssetSearchMode="PUBLIC_ONLY"
          customPlaceholder="Search for any investment"
          refreshedStyling
          displayResultsAsBlock
          excludedItems={excludedItems}
          hasDropdown={false}
          className="[&_.select\_\_control]:mx-[16px] [&_.select\_\_menu-notice]:mx-[16px] last:td:pr-[16px]"
        />
      </div>
      {allowBackStep && (
        <ModalFooter
          className="!bg-venn-white px-[16px] py-[12px] border-0 border-t border-solid border-venn-grey-30 h-[64px]"
          leftChildren={
            <Button refreshedStyling noMargin icon="chevron-left" onClick={handleBack}>
              Back
            </Button>
          }
        />
      )}
    </>
  );
};
